<template>
	<div v-title title="我的" class="overwrite_productList user_bg" style="
      height: 100vh;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #f7f8fa;
    ">
		<div class="user_title_box" style="">
			<van-image class="img" :src="userPic" />
			<div class="name">
				{{ form.user.username }}
			</div>
		</div>

		<div style="margin: 0 10px; width: 95%"></div>

		<div class="order-box">
			<div class="title-line">
				<span class="title">我的订单</span>
				<span class="flex1"></span>
				<span class="text" @click="goToOrder('')">查看全部</span>
				<img class="icon" src="@/assets/images/user/icon_more@3x.png" @click="goToOrder('')" />
			</div>
			<div class="order-type-list">
				<div class="order-type-item" @click="goToOrder('0')">
					<img class="img" src="@/assets/images/user/icon_dfk@3x.png" />
					<span class="name">待付款</span>
					<div class="badge" v-if="form.userBizInfo.pendingPayCnt">{{ form.userBizInfo.pendingPayCnt }}</div>
				</div>
				<div class="order-type-item" @click="goToOrder('2')">
					<img class="img" src="@/assets/images/user/icon_dfh@3x.png" />
					<span class="name">待发货</span>
					<div class="badge" v-if="form.userBizInfo.pendingDeliveryCnt">{{ form.userBizInfo.pendingDeliveryCnt }}</div>
				</div>
				<div class="order-type-item" @click="goToOrder('3')">
					<img class="img" src="@/assets/images/user/icon_dsh@3x.png" />
					<span class="name">待收货</span>
					<div class="badge" v-if="form.userBizInfo.pendingReceiveCnt">{{ form.userBizInfo.pendingReceiveCnt }}</div>
				</div>
				<div class="order-type-item" @click="goToOrder('8')">
					<img class="img" src="@/assets/images/user/icon_dpj@3x.png" />
					<span class="name">待评价</span>
					<div class="badge" v-if="form.userBizInfo.pendingCommentCnt">{{ form.userBizInfo.pendingCommentCnt }}</div>
				</div>
				<div class="order-type-item" @click="goToShouhou">
					<img class="img" src="@/assets/images/user/icon_sh@3x.png" />
					<span class="name">售后</span>
					<div class="badge" v-if="form.userBizInfo.processingReturnCnt">{{ form.userBizInfo.processingReturnCnt }}
					</div>
				</div>
			</div>
		</div>

		<div class="line-list">
			<div class="line-item" @click="goCoupon">
				<img class="icon" src="@/assets/images/user/icon_yhq@3x.png" />
				<span class="text">优惠券</span>
				<span class="flex1"></span>
				<span class="text grey">{{ form.userBizInfo.pendingUseCouponCnt }}张可用</span>
				<img class="icon-more" src="@/assets/images/user/icon_more@3x.png" />
			</div>
			<div class="line-item" @click="goAddress">
				<img class="icon" src="@/assets/images/user/icon_dz@3x.png" />
				<span class="text">地址管理</span>
				<span class="flex1"></span>
				<img class="icon-more" src="@/assets/images/user/icon_more@3x.png" />
			</div>
			<div class="line-item" @click="showPhone = !showPhone">
				<img class="icon" src="@/assets/images/user/icon_tel@3x.png" />
				<span class="text">客服电话</span>
				<span class="flex1"></span>
				<span class="text grey">{{ shop.customerServicePhone }}</span>
				<img class="icon-more" src="@/assets/images/user/icon_more@3x.png" />
			</div>
		</div>

		<van-form @submit="submit">
			<TabBar active="user"> </TabBar>
		</van-form>

		<van-overlay :show="showPhone" @click="showPhone = false">
			<div class="wrapper" @click.stop>
				<div class="block">
					<img class="bg" src="@/assets/images/user/bg_serve.png" />
					<div class="tel" @click="phoneNumber">{{ shop.customerServicePhone }}</div>
					<div class="tips">服务时间：{{ shop.customerServiceTime.substring(0, 11) }}{{
				shop.customerServiceTime.substring(
					11,
					shop.customerServiceTime.length
				)
			}}</div>
					<div class="btn" @click="showPhone = false">我知道了</div>
				</div>
			</div>
		</van-overlay>

		<div td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/user" ref="maidian"></div>
	</div>
</template>

<script>
import { get } from 'api/get'
import TabBar from '@/components/tabBar/index'
import UserPic from '@/assets/images/user.jpg'

export default {
	name: 'User',
	components: {
		TabBar,
	},
	data() {
		return {
			value: '',
			userPic: UserPic,
			border: false,
			showPhone: false,
			form: {
				user: {},
				userBizInfo: {
					pendingPayCnt: 0,
					pendingDeliveryCnt: 0,
					pendingReceiveCnt: 0,
					pendingCommentCnt: 0,
					processingReturnCnt: 0,
					pendingUseCouponCnt: 0,
				},
			},
			shop: {
				name: '',
				logo: '',
				invoiceProvideCompany: '',
				customerServicePhone: '',
				customerServiceTime: '',
				onlineServiceTime: '',
				businessLicense: '',
			},
		}
	},
	created() {
		this.loadUserInfo()
		this.getShopDetail()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		phoneNumber() {
			window.location.href = 'tel://' + this.shop.customerServicePhone
		},
		loadUserInfo() {
			let self = this
			get('sso/info').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.form = JSON.parse(JSON.stringify(res.data))
					if (self.form.user.username.length > 10) {
						self.form.user.username = self.form.user.username.substring(0, 10) + '...'
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a',
					})
				}
			})
		},
		submit() { },
		goAddress() {
			this.$router.push('/addressList')
		},
		goCoupon() {
			this.$router.push('/couponList')
		},
		goToOrder(v) {
			this.$router.push({
				path: '/orderList',
				query: {
					status: v,
				},
			})
		},
		goToShouhou() {
			this.$router.push('/shouhouList')
		},
		getShopDetail() {
			let self = this
			this.$get('setting/sysParam/sys_shop_param').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					self.shop.invoiceProvideCompany = resData.find(
						(i) => i.dictLabel == '发票提供公司'
					).dictValue
					self.shop.customerServicePhone = resData.find(
						(i) => i.dictLabel == '商城客服电话'
					).dictValue
					self.shop.customerServiceTime = resData.find(
						(i) => i.dictLabel == '商城服务时间'
					).dictValue
					self.shop.date = resData.find(
						(i) => i.dictLabel == '商城服务日期'
					).dictValue
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a',
					})
				}
			})
		},
	},
}
</script>

<style scoped lang="less">
.user_bg {
	background: url('../../../static/images/bg_user_top.png') no-repeat;
	background-size: 100%;
}

.user_title_box {
	box-sizing: border-box;
	width: 100%;
	height: 78px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: flex-start;
	align-items: center;
	padding: 10px 22px 0;

	.img {
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}

	.name {
		max-width: 280px;
		height: 20px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		line-height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}



.order-box {
	margin: 0 auto;
	box-sizing: border-box;
	padding: 12px;
	width: 355px;
	height: 110px;
	background: #FFFFFF;
	border-radius: 10px;

	.title-line {
		height: 18px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		// padding: 0 12px;

		.flex1 {
			flex: 1;
		}

		.title {
			height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #333333;
			line-height: 18px;
			text-align: left;
			font-style: normal;
		}

		.text {
			height: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 11px;
			color: #999999;
			line-height: 14px;
		}

		.icon {
			width: 12px;
			height: 12px;
		}
	}

	.order-type-list {
		margin-top: 14px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		align-items: center;
		justify-content: space-between;
	}

	.order-type-item {
		display: flex;
		flex-direction: column;
		padding: 0 10px;
		position: relative;

		.img {
			width: 34px;
			height: 34px;
		}

		.name {
			margin-top: 4px;
			height: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			line-height: 14px;
			text-align: center;
			font-style: normal;
		}

		.badge {
			width: 14px;
			height: 14px;
			background: #FF4E4E;
			border-radius: 50%;
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			font-size: 10px;
			color: #FFFFFF;
			line-height: 14px;
			text-align: center;
			position: absolute;
			top: -3px;
			right: 3px;
		}
	}

}

.line-list {
	box-sizing: border-box;
	margin: 10px auto;
	width: 355px;
	height: 144px;
	background: #FFFFFF;
	border-radius: 10px;
	padding: 0 12px;

	.line-item {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		height: 48px;
		border-bottom: 1px solid #EEEEEE;

		.icon {
			width: 16px;
			height: 16px;
			margin-right: 6px;
		}

		.text {
			height: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
			line-height: 16px;
		}

		.flex1 {
			flex: 1
		}

		.grey {
			font-size: 11px;
			color: #999999;
		}

		.icon-more {
			width: 12px;
			height: 12px;
		}
	}

	.line-item:last-child {
		border: none;
	}
}

.block {
	box-sizing: border-box;
	margin: 40% auto;
	padding: 20px;
	width: 254px;
	height: 270px;
	background: linear-gradient(180deg, #E3FFF2 0%, #FBFCFE 35%, #FFFFFF 100%);
	border-radius: 22px;

	.bg {
		display: block;
		margin: 0 auto;
		width: 150px;
		height: 78px;
	}

	.tel {
		margin: 30px auto 0;
		width: 169px;
		height: 30px;
		font-family: 'DINA';
		font-weight: bold;
		font-size: 30px;
		color: #333333;
		line-height: 30px;
		text-align: center;
	}

	.tips {
		margin: 6px auto 0;
		height: 16px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #666666;
		line-height: 16px;
		text-align: center;
	}

	.btn {
		margin: 30px auto 0;
		width: 214px;
		height: 40px;
		background: #00754A;
		border-radius: 10px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 15px;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/user/user.vue